import React from "react";
import { useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import FWWIcon from "@icons/myicons/fww.svg?react";
import { useRecommendationDetails } from "../../../RecommendationDetailsProvider";
import {
  createBankRow,
  createDistributionTypeRow,
  createIconRow,
  createBooleanRow,
} from "./helper";
import { InfoRowProps } from "./InfoRow";

const NO_VALUE = "-";

export const useGetProductInfo = (): InfoRowProps[] => {
  const theme = useTheme();
  const { t } = useTranslation();
  const { investmentFundDetails, fundDetails } = useRecommendationDetails();

  return [
    {
      label: t("recommender.compareView.productInfo.rows.provider"),
      value1: investmentFundDetails?.emitter ?? NO_VALUE,
      value2: fundDetails?.emitter ?? NO_VALUE,
    },
    {
      label: t("recommender.compareView.productInfo.rows.replicationMethod"),
      value1: NO_VALUE,
      value2: NO_VALUE,
    },
    {
      label: t("recommender.compareView.productInfo.rows.distributionPolicy"),
      value1: createDistributionTypeRow(
        theme,
        t,
        investmentFundDetails?.dividendDistributionType
      ),
      value2: createDistributionTypeRow(
        theme,
        t,
        fundDetails?.dividendDistributionType
      ),
    },
    {
      label: t("recommender.compareView.productInfo.rows.directPurchaseVia"),
      value1: createBankRow(investmentFundDetails?.commissions),
      value2: createBankRow(fundDetails?.commissions),
    },
    {
      label: t("recommender.compareView.productInfo.rows.savingsPlan"),
      value1: createBooleanRow(theme, investmentFundDetails?.hasSavingsPlan),
      value2: createBooleanRow(theme, fundDetails?.hasSavingsPlan),
    },
    {
      label: t("recommender.compareView.productInfo.rows.payoutPlans"),
      value1: createBooleanRow(theme, investmentFundDetails?.hasWithdrawalPlan),
      value2: createBooleanRow(theme, fundDetails?.hasWithdrawalPlan),
    },
    {
      label: <FWWIcon />,
      value1: createIconRow(
        theme,
        "star",
        investmentFundDetails?.fundamentals?.ratingFwwFundstars
      ),
      value2: createIconRow(
        theme,
        "star",
        fundDetails?.fundamentals?.ratingFwwFundstars
      ),
    },
    {
      label: t("recommender.compareView.productInfo.rows.sustainability"),
      value1: createIconRow(
        theme,
        "leaf",
        investmentFundDetails?.sustainabilityIndicators
          ?.aggregatedSustainabilityRating
      ),
      value2: createIconRow(
        theme,
        "leaf",
        fundDetails?.sustainabilityIndicators?.aggregatedSustainabilityRating
      ),
    },
    {
      label: t("recommender.compareView.productInfo.rows.popularity"),
      value1: NO_VALUE,
      value2: NO_VALUE,
    },
    {
      label: t(
        "recommender.compareView.productInfo.rows.diversificationOverlapTitle"
      ),
      value1: NO_VALUE,
      value2: NO_VALUE,
    },
  ];
};
